import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  VStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";

export default function MultiSelectDropdown({
  options = [],
  value = [],
  onChange,
  placeholder = "Select options",
}) {
  const [selected, setSelected] = useState(value);

  const handleChange = (vals) => {
    setSelected(vals);
    onChange(vals);
  };

  return (
    <Popover placement="bottom-start" closeOnBlur={false}>
      <PopoverTrigger>
        <Button w="100%" variant="filled" textAlign="left">
          {selected.length > 0
            ? `${selected.length} selected`
            : placeholder}
        </Button>
      </PopoverTrigger>

      <PopoverContent w="250px">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody maxH="250px" overflowY="auto">
          <CheckboxGroup value={selected} onChange={handleChange}>
            <VStack align="start" spacing={2}>
              {options.map((opt) => (
                <Checkbox key={opt._id} value={opt._id}>
                  {opt.name}
                </Checkbox>
              ))}
            </VStack>
          </CheckboxGroup>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
